module.exports = __webpack_public_path__ + "img/bluespeedlogo-transparent.1ecad419.png";